module.exports = __webpack_public_path__ + "static/media/map11.82623825.webp";